// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"CancelConfigurationModal_buttonGroup__LTYsk","infoText":"CancelConfigurationModal_infoText__2IDdo"};